import * as React from 'react';
export const TableHeadCell = ({ as = 'th', sortable, ...rest }) => {
    const native = as === 'th';
    const sort = rest['aria-sort'];
    return React.createElement(as, {
        role: !native ? 'columnheader' : undefined,
        ...rest,
        'aria-sort': !native && sortable ? 'none' : sort,
    });
};
